import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Email Templates*/
export const registerEmailTemplate = async (emailTemplateData) => {
  try {
    const response = await api.post("/email-templates", emailTemplateData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "email template");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchEmailTemplatesFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, sort = {}) => {
  try {
    // Build params object with column-specific filters
    const params = {
      page,
      per_page: perPage
    };

    // Add search parameter if provided (for backward compatibility)
    if (search) {
      params.search = search;
    }

    // Add column-specific parameters
    if (columnFilters.template_name) params.template_name = columnFilters.template_name;
    if (columnFilters.template_type) params.template_type = columnFilters.template_type;
    if (columnFilters.subject) params.subject = columnFilters.subject;
    if (columnFilters.is_active) params.is_active = columnFilters.is_active;

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }

    const response = await api.get("/email-templates", {
      params: params,
    });

    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "email template");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* Fetch every template matching the filters, walking server pages (for Export). */
export const fetchAllEmailTemplatesForExport = async ({ search = "", columnFilters = {}, sort = {} } = {}, onProgress) => {
  const PER_PAGE = 1000;
  const collected = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const response = await fetchEmailTemplatesFromAPI(page, PER_PAGE, search, columnFilters, sort);
    const payload = response?.data || {};
    const rows = Array.isArray(payload.emailTemplates) ? payload.emailTemplates : [];
    collected.push(...rows);
    total = Number(payload.pagination?.total) || collected.length;
    if (onProgress) onProgress(collected.length, total);
    const lastPage = Number(payload.pagination?.last_page) || 1;
    if (rows.length === 0 || page >= lastPage || collected.length >= total) break;
    page += 1;
  }
  return collected;
};

export const deleteEmailTemplatesFromAPI = async (emailTemplateId) => {
  try {
    const response = await api.delete(`/email-templates/${emailTemplateId}`, {
      data: { id: emailTemplateId }
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete", "email template");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateEmailTemplate = async (emailTemplateId, emailTemplateData) => {
  try {
    const response = await api.put(`/email-templates/${emailTemplateId}`, emailTemplateData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "email template");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchEmailTemplateByIdFromAPI = async (emailTemplateId) => {
  try {
    const response = await api.get(`/email-templates/${emailTemplateId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "email template");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const uploadEmailTemplateFileToAPI = async (formData) => {
  try {
    const response = await api.post("/email-templates/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload", "email template file");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
